import { interpolate } from "d3-interpolate";
import { Arc, PieArcDatum } from "d3-shape";
import { ChartDimensions, DataEntry, PositionedPieLabel } from "./donut-chart";

export function sliceInterpolator(
    newValue: PieArcDatum<DataEntry>,
    oldValue: PieArcDatum<DataEntry>
) {
    var i = interpolate(oldValue || newValue, newValue);
    return function (arcFn: Arc<any, PieArcDatum<DataEntry>>, t: number) {
        return arcFn(i(t));
    };
}

export function polylineInterpolator(
    newValue: PositionedPieLabel<DataEntry>,
    oldValue: PositionedPieLabel<DataEntry>,
    dimensions: ChartDimensions
) {
    const newPolylinePoints = definePolylinePoints(newValue, dimensions);
    const oldPolylinePoints = oldValue
        ? definePolylinePoints(oldValue, dimensions)
        : newPolylinePoints;
    const i = interpolate<number[][]>(oldPolylinePoints, newPolylinePoints);
    return (t: number) => {
        return i(t).join(",");
    };
}

export function labelInterpolator(
    newValue: { x: number; y: number },
    oldValue: { x: number; y: number }
) {
    const old = oldValue || newValue;
    const i = interpolate<number[]>([old.x, old.y], [newValue.x, newValue.y]);
    return (t: number, yOffset: number) => {
        const [x, y] = i(t);
        return `${x},${y - yOffset}`;
    };
}

function definePolylinePoints(
    d: PositionedPieLabel<DataEntry>,
    size: ChartDimensions
) {
    const posA = size.arcFn.centroid(d); // line insertion in the slice
    const posB = [size.outerArcFn.centroid(d)[0], d.y]; // line break: we use the other arc generator that has been built only for that
    const posC = [
        // Label position = almost the same as posB
        size.radius *
            (size.labelRadiusFactor - 0.05) *
            (d.midangle < Math.PI ? 1 : -1), // multiply by 1 or -1 to put left or right
        d.y,
    ];

    return [posA, posB, posC];
}
